module.exports = __webpack_public_path__ + "static/maxresdefault.fe8dc5e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/git-github-presentation/maxresdefault.jpg
// module id = 1075
// module chunks = 32308089046778